import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { INonAllocatedSimModel } from '@apps-common/types/management/non-allocated-sim'

export const MANAGEMENT_QUERY_KEY_SEARCH_NON_ALLOCATED_SIMS = (search?: string) => ['searchNonAllocatedSims', search].filter(Boolean)

export const searchNonAllocatedSims = async (search?: string): Promise<INonAllocatedSimModel[]> =>
  axios.get(`/management/nonallocatedsim/SearchNonAllocatedSims?search=${search}`).then((res) => res.data?.data)

type QueryFnType = typeof searchNonAllocatedSims

type Props = {
  config?: QueryConfig<QueryFnType>
  search?: string
}

export const useManagementGetNonAllocatedSims = ({ config, search }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: MANAGEMENT_QUERY_KEY_SEARCH_NON_ALLOCATED_SIMS(search),
    queryFn: () => searchNonAllocatedSims(search)
  })
